module.exports = __webpack_public_path__ + "media/footer/pinterest-4bc6ac23.svg";